import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgNewsMode(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3406_13642)">
        <path
          d="M1.5 15C1.0875 15 0.734375 14.8531 0.440625 14.5594C0.146875 14.2656 0 13.9125 0 13.5V2.5C0 2.0875 0.146875 1.73438 0.440625 1.44063C0.734375 1.14688 1.0875 1 1.5 1H14.5C14.9125 1 15.2656 1.14688 15.5594 1.44063C15.8531 1.73438 16 2.0875 16 2.5V13.5C16 13.9125 15.8531 14.2656 15.5594 14.5594C15.2656 14.8531 14.9125 15 14.5 15H1.5ZM1.5 13.5H14.5V2.5H1.5V13.5ZM3 11.5H13V10H3V11.5ZM3 8.5H6.5V4H3V8.5ZM8 8.5H13V7H8V8.5ZM8 5.5H13V4H8V5.5Z"
          fill="#1F1F1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_3406_13642">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(0 -1 1 0 0 16)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
